export default __webpack_public_path__ + "static/1060-c43d993e4484a3e5684299fbbade0fe1.gif";